export default [
    {
        value: "AutoProduto",
        text: "AUTO-PRODUTOR",
      },
      {
        value: "Concessionaria",
        text: "CONCESSIONÁRIA",
      },
      {
        value: "Permissionaria",
        text: "PERMISSIONÁRIA",
      },
      {
        value: "ProdutorIndependente",
        text: "PRODUTOR INDEPENDENTE",
      }
]